export default "__VITE_ASSET__ye2vYkeK__"